__webpack_require__.p = "/putting-game/";